import React, { useEffect, useState, useRef } from "react";
import { Button, Card, Col, Form, Input, Popconfirm, Row, Select, SelectProps, Space, Tooltip, Modal, DatePicker } from "antd";
import { useParams } from "react-router-dom";
import HTTPService from "../../../utils/makerequest";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { IPageProps } from "../../../interfaces/page-data";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";
import { IInventory } from "../../../interfaces/IItemData";
import { useTranslation } from "react-i18next";
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined, UnorderedListOutlined, SaveOutlined, CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { Box, Tab, Tabs } from "@material-ui/core";
import LaborTask from "./Modal/LaborTask";
import { Toast } from 'primereact/toast';
import { FormInstance } from "antd/lib/form";
import AddActivityName from "./AddActivityName";
import { IUser } from "../../../interfaces/IUser";
import Dropdown from "../../../AltisComponent/Dropdown";

const AddCare: React.FunctionComponent<IPageProps> = (props) => {
    const { maintenanceId } = useParams<any>();
    const [careData, setCareData] = useState<any>();
    const [companyData, setCompanyData] = useState<ICompanyData[]>();
    const [selectedCompany, setSelectedCompany] = useState<number | undefined>(undefined);
    const [activityData, setActivityData] = useState<any>();
    const [inventoryData, setInventoryData] = useState<IInventory>();
    const [selectedActivityType, setSelectedActivityType] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [maintenanceType, setMaintenanceType] = useState<number>();
    const [isModalVisibleCare, setIsModalVisibleCare] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const { t } = useTranslation();
    const toast = useRef<Toast>(null);
    const [form] = Form.useForm();
    const [showCustomFrequency, setShowCustomFrequency] = useState(false);
    const [showRepeatCount, setShowRepeatCount] = useState(false);
    const [repeatBase, setRepeatBase] = useState<number>(0);
    const [calculatedDates, setCalculatedDates] = useState<string[]>([]);
    const [repeatMaintenanceDetail, setRepeatMaintenanceDetail] = useState<string[]>([]);
    const [selectedActivity, setSelectedActivity] = useState<number | undefined>(form.getFieldValue('activityId'));
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [userData, setUserData] = useState<IUser[]>();

    useEffect(() => {
        props.onSetPage({
            title: t('maintenanceAndFaiuure')
        });

        // Only load inventory and fetch data initially
        InventoryFilter();
        fetchData();
        fetchActivity(userInfo?.companyId);
        getUserData(userInfo?.companyId);

        // Only fetch care data if maintenanceId exists and is not 0
        if (maintenanceId && parseInt(maintenanceId) !== 0) {
            getCareId(parseInt(maintenanceId));
        } else {
            // Reset care data for new form
            setCareData({
                repeatMaintenanceTBL: [],
                count: 0
            });
        }
    }, []);

    useEffect(() => {
        setShowCustomFrequency(form.getFieldValue('repeatActivity') === 'Custom');
    }, [form.getFieldValue('repeatActivity')]);

    const fetchData = async () => {
        const result = await HTTPService.GETCompanyNames();
        setCompanyData(result);
    };

    const handleMaintenanceTypeChange = (value: number) => {
        setMaintenanceType(value);
    };

    const getUserData = (companyId: number) => {
        HTTPService.GET(`/User/allUserName?companyId=${companyId}`)
            .then((res) => {
                if (!res.data) {
                    return;
                }
                if (res.status === 200) {
                    setUserData(res.data);
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: res.error.message,
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    };

    const savedNewCare = async (newActivity: any) => {
        try {
            setActivityData(prevData => {
                const updatedData = prevData ? [...prevData] : [];
                updatedData.push(newActivity);
                return updatedData;
            });

            form.setFieldValue('activityId', newActivity.activityId);
            setSelectedActivity(newActivity.activityId);

            setIsModalVisibleCare(false);

            toast.current?.show({
                severity: 'success',
                summary: t('successful'),
                detail: t('activity_added_successfully'),
                life: 3000
            });
        } catch (error) {
            console.error('Error saving activity:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_saving_activity'),
                life: 3000
            });
        }
    };

    const getCareId = (maintenanceId: number) => {
        HTTPService.GET(`/Maintenance/MaintenanceById?maintenanceId=${maintenanceId}`)
            .then((res) => {
                if (res.status === 200 && res.data) {
                    setCareData(res.data);
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: res.error?.message || t('error_fetching_data'),
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('error_fetching_data'),
                    life: 3000
                });
                console.error("Error fetching brand data:", error);
            });
    };

    const columns: IMUIDataGridColumns[] = [
        ...(userInfo.role !== UserRole.Admin
            ? [
                {
                    title: t('Company Name'),
                    key: 'companyName',
                    placeHolder: t('Company Name'),
                    isSorting: true,
                },
            ]
            : []),
        {
            title: t('inventoryName'),
            headerAlign: 'center',
            align: 'left',
            key: 'inventoryName',
            placeHolder: t('inventoryName'),
            width: 250
        },
        {
            title: t('barcode'),
            isSorting: true,
            key: 'barcode',
            placeHolder: t('barcode'),
            width: 250
        },
        {
            title: t('item_type'),
            isSorting: true,
            key: 'typeName',
            placeHolder: t('item_type'),
            width: 250
        },
        {
            title: t('item_group'),
            isSorting: true,
            key: 'categoryName',
            placeHolder: t('item_group'),
            width: 250
        },
        {
            title: t('location'),
            isSorting: true,
            key: 'locationName',
            placeHolder: t('actualLocation'),
            width: 250,
            render: (text, record) => (
                <div>
                    <span>{text}</span>
                    {record.locationName !== record.actualLocationName && (
                        <Tooltip title={record.actualLocationName}>
                            <span style={{ color: 'red', marginLeft: 8, cursor: 'pointer' }}>⚠️</span>
                        </Tooltip>
                    )}
                </div>
            ),
        },
        {
            title: t('inventory_status_name'),
            isSorting: true,
            key: 'inventoryStatusName',
            placeHolder: t('inventory_status_name'),
            width: 250
        },
    ];

    const columns1: IMUIDataGridColumns[] = [
        {
            title: t('inventoryName'),
            headerAlign: 'center',
            align: 'left',
            key: 'inventoryName',
            placeHolder: t('inventoryName'),
            width: 485,
            render: (text, record) => record?.inventoryTBL?.inventoryName
        },
        {
            title: t('barcode'),
            isSorting: true,
            key: 'barcode',
            placeHolder: t('barcode'),
            width: 490,
            render: (text, record) => record?.inventoryTBL?.barcode
        },
        {
            title: t('operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            isSorting: true,
            render: (order, record) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Space>
                        <Popconfirm
                            title={t('confirm_delete')}
                            onConfirm={() => handleDeleteItem(record.inventoryId)}
                            okText={t('yes')}
                            cancelText={t('no')}
                        >
                            <Tooltip title={t('delete')} placement="top">
                                <Button
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    style={{
                                        display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                                        width: '40px',
                                        minWidth: '40px',
                                        borderRadius: '20px'
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </Tooltip>
                        </Popconfirm>
                    </Space>
                </div>
            ),
        }
    ];

    const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
        return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
    };

    const InventoryFilter = (e?) => {
        const filters = e?.filters;
        const body = {
            sortColumn: e?.sortField || '',
            sortOrder: e?.sortOrder || 'asc',
            pageSize: e?.pageSize || 10,
            page: e?.page || 1,
            barcode: filters?.barcode,
            customBarcode: filters?.barcode,
            departmentName: filters?.departmentName,
            inventoryName: filters?.inventoryName,
            inventoryStatusName: filters?.inventoryStatusName,
            typeName: filters?.typeName,
            debtFirstName: filters?.debtFirstName,
            debtLastName: filters?.debtLastName,
            companyId: e?.companyId,
            companyName: filters?.companyName,
            itemName: filters?.itemName,
            itemGroup: e?.itemGroup,
            locationName: filters?.locationName,
            categoryName: filters?.categoryName,
            debbit: e?.debbit,
            responsible: e?.responsible,
            isPrinted: e?.isPrinted,
        };

        HTTPService.POST(`/Inventory/filters`, body).then((response) => {
            if (response.status === 200 && response.data) {
                setInventoryData(response.data);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: response.data,
                    life: 3000
                });
            }
        });
    };

    const handleAddSelectedItems = () => {
        if (!selectedRows || selectedRows.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: t('Warning'),
                detail: t('no_items_selected'),
                life: 3000
            });
            return;
        }

        setCareData(prev => {
            const existingItems = prev?.repeatMaintenanceTBL || [];
            const existingIds = new Set(existingItems.map(item => item.inventoryId));
            const newItems = selectedRows
                .filter(item => !existingIds.has(item.inventoryId))
                .map(item => ({
                    inventoryId: item.inventoryId,
                    inventoryTBL: {
                        inventoryName: item.inventoryName,
                        barcode: item.customBarcode || item.barcode
                    }
                }));

            if (newItems.length === 0) {
                toast.current?.show({
                    severity: 'warn',
                    summary: t('info'),
                    detail: t('alreadyExists'),
                    life: 3000
                });
                return prev;
            }

            const updated = {
                ...prev,
                repeatMaintenanceTBL: [...existingItems, ...newItems],
                count: (existingItems.length + newItems.length)
            };

            toast.current?.show({
                severity: 'success',
                summary: t('success'),
                detail: t('assetAdd'),
                life: 3000
            });

            return updated;
        });

        setSelectedRows([]);
    };

    const handleRowSelection = (newSelection: any[]) => {
        setSelectedRows(newSelection);
    };

    const handleDeleteItem = (inventoryId: number) => {
        const updatedRepeatMaintenanceTBL = careData?.repeatMaintenanceTBL.filter(
            item => item.inventoryId !== inventoryId
        );

        setCareData({
            ...careData,
            repeatMaintenanceTBL: updatedRepeatMaintenanceTBL
        });

        toast.current?.show({
            severity: 'success',
            summary: t('success'),
            detail: t('inventory_delete'),
            life: 3000
        });
    };

    const registerCare = (formData) => {
        try {
            if (!careData?.repeatMaintenanceTBL || careData.repeatMaintenanceTBL.length === 0) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('please_select_inventory'),
                    life: 3000
                });
                return;
            }

            const startDate = moment(formData.maintenanceStartDate);
            const finishDate = moment(formData.maintenanceFinishDate);
            const repeatCount = formData.repeatActivity === 'Custom'
                ? Number(formData.customRepeatCount)
                : Number(formData.repeatCount);
            const repeatValue = formData.repeatActivity === 'Custom'
                ? Number(formData.frequency)
                : Number(formData.repeatActivity);

            if (finishDate && repeatCount > 1) {
                const daysDifference = finishDate.diff(startDate, 'days');
                const requiredDays = (repeatCount - 1) * (repeatValue);

                if (requiredDays > daysDifference) {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t('invalid_repeat_count_for_date_range', {
                            count: repeatCount,
                            days: daysDifference + 1,
                            required: requiredDays + 1
                        }),
                        life: 5000
                    });
                    return;
                }
            }

            const maintenanceData = {
                inventoryId: careData?.repeatMaintenanceTBL?.map(item => item.inventoryId) || [],
                companyId: formData.companyId || userInfo.companyId,
                activityId: formData.activityId,
                description: formData.description,
                maintenanceStartDate: moment(formData.maintenanceStartDate).format('YYYY-MM-DDTHH:mm:ss'),
                maintenanceFinishDate: moment(formData.maintenanceFinishDate).format('YYYY-MM-DDTHH:mm:ss'),
                maintenanceType: 1,
                repeatMaintenance: repeatValue,
                maintenanceResponsible: formData.maintenanceResponsible,
                maintenanceResponsibleUserId: formData.maintenanceResponsibleUserId,
                maintenanceExternalResponsibleName: formData.maintenanceExternalResponsibleName,
                maintenanceExternalResponsibleMail: formData.maintenanceExternalResponsibleMail,
                maintenanceCreatedUserId: userInfo?.userId,
                priority: Number(formData.Priority),
                repeatMaintenanceDetail: repeatMaintenanceDetail,
                maintenanceList: []
            };

            HTTPService.POST(`/Maintenance/registerMaintenance`, maintenanceData)
                .then((res) => {
                    if (res.status === 200) {
                        toast.current?.show({
                            severity: 'success',
                            summary: t('success'),
                            detail: t('maintenanceCreated'),
                            life: 3000
                        });
                        window.location.replace("/admin/care-management/");
                    } else {
                        const errorMessage = typeof res.data === 'string' ? res.data : t('save_failed');
                        toast.current?.show({
                            severity: 'error',
                            summary: t('errors'),
                            detail: errorMessage,
                            life: 3000
                        });
                    }
                })
                .catch((error) => {
                    console.error('Save Error:', error);
                    const errorMessage = error?.response?.data?.title || t('save_failed');
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: errorMessage,
                        life: 3000
                    });
                });

        } catch (error) {
            console.error('Form processing error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('save_failed'),
                life: 3000
            });
        }
    };

    const handleCancelCare = () => {
        setIsModalVisibleCare(false);
    };

    const handleCancel = () => {
        window.location.replace("/admin/care-management/");
    };

    const showModal = () => {
        setIsModalVisible(true);
        InventoryFilter();
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
    };

    const fetchActivity = async (companyId: number) => {
        try {
            const result = await HTTPService.GETActivityNames(companyId);
            const faultActivities = result.filter(activity => activity.maintenanceType === 1);
            setActivityData(faultActivities);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const handleChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };

    const getMaintenanceTypeValue = (maintenanceType: number) => {
        return maintenanceType === 1 ? 1 : 2;
    };

    const getRepeatActivityValueOld = (repeatMaintenance?: number) => {
        if (repeatMaintenance === undefined || repeatMaintenance === null) {
            return undefined;
        }

        switch (repeatMaintenance) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 7:
                return 7;
            case 30:
                return 30;
            case 365:
                return 365;
            case -1:
                return 'Custom';
            default:
                return undefined;
        }
    };

    const showModalCare = () => {
        setIsModalVisibleCare(true);
    };

    const isDateInRange = (date: moment.Moment, startDate: moment.Moment, endDate: moment.Moment | null) => {
        if (!endDate) return true;
        return date.isSameOrBefore(endDate) && date.isSameOrAfter(startDate);
    };

    const calculateDates = (startDate: moment.Moment, repeatValue: number, repeatCount: number) => {
        const dates: string[] = [];
        const isoDates: string[] = [];
        let currentDate = moment(startDate);
        const endDate = form.getFieldValue('maintenanceFinishDate');

        if (isDateInRange(currentDate, startDate, endDate)) {
            dates.push(currentDate.format('DD.MM.YYYY'));
            isoDates.push(currentDate.format('YYYY-MM-DD'));
        }

        let count = 1;
        while (count < repeatCount) {
            currentDate = moment(currentDate).add(repeatValue, 'days');

            if (endDate && currentDate.isAfter(endDate)) {
                break;
            }

            if (isDateInRange(currentDate, startDate, endDate)) {
                dates.push(currentDate.format('DD.MM.YYYY'));
                isoDates.push(currentDate.format('YYYY-MM-DD'));
                count++;
            }
        }

        if (count < repeatCount) {
            toast.current?.show({
                severity: 'warn',
                summary: t('warning'),
                detail: t('repeat_count_reduced_due_to_end_date', {
                    actual: count,
                    planned: repeatCount
                }),
                life: 5000
            });
        }

        setRepeatMaintenanceDetail(isoDates);
        return dates;
    };

    // handleRepeatCountChange fonksiyonunu güncelle
    const handleRepeatCountChange = (e: any) => {
        const count = Number(e.target.value);
        const startDate = form.getFieldValue('maintenanceStartDate');
        const endDate = form.getFieldValue('maintenanceFinishDate');
        const repeatType = form.getFieldValue('repeatActivity');

        if (!e.target.value || count === 0) {
            setCalculatedDates([]);
            return;
        }

        if (!startDate) {
            toast.current?.show({
                severity: 'warn',
                summary: t('warning'),
                detail: t('please_select_start_date'),
                life: 3000
            });
            return;
        }

        if (!endDate) {
            toast.current?.show({
                severity: 'warn',
                summary: t('warning'),
                detail: t('end_date_not_selected'),
                life: 3000
            });
        }

        if (startDate && repeatType && count) {
            let baseValue = 0;
            switch (repeatType) {
                case 1: baseValue = 1; break;     // Günlük
                case 7: baseValue = 7; break;     // Haftalık
                case 30: baseValue = 30; break;   // Aylık
                case 365: baseValue = 365; break; // Yıllık
                default: baseValue = 0;
            }

            const dates = calculateDates(startDate, baseValue, count);
            setCalculatedDates(dates);
        }
    };

    // Ortak stil objesi oluştur
    const calculatedDatesStyles = {
        container: {
            marginBottom: '20px',
            padding: '10px',
            border: '1px solid #d9d9d9',
            borderRadius: '5px',
            backgroundColor: '#fafafa'
        },
        header: {
            marginBottom: '8px',
            fontWeight: 'bold',
            color: '#1890ff'
        },
        dateRow: {
            marginBottom: '4px',
            padding: '4px 8px',
            borderRadius: '4px'
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <Form
                layout="vertical"
                onFinish={registerCare}
                form={form}
                fields={
                    maintenanceId && parseInt(maintenanceId) !== 0
                        ? [
                            {
                                name: ["activityId"],
                                value: careData?.activityId
                            },
                            { name: ["description"], value: careData?.description },
                            { name: ["priority"], value: careData?.priority },
                            { name: ["maintenanceResponsible"], value: careData?.maintenanceResponsible },
                            { name: ["maintenanceStartDate"], value: careData?.maintenanceStartDate ? moment(careData?.maintenanceStartDate) : undefined },
                            { name: ["maintenanceFinishDate"], value: careData?.maintenanceFinishDate ? moment(careData?.maintenanceFinishDate) : undefined },
                            {
                                name: ["repeatActivity"],
                                value: selectedActivityType !== undefined
                                    ? getRepeatActivityValueOld(selectedActivityType)
                                    : undefined
                            },
                            { name: ["maintenanceType"], value: getMaintenanceTypeValue(careData?.maintenanceType) }
                        ]
                        : []
                }
            >
                <Card style={{ padding: "50px" }}>
                    <Box sx={{ width: "100%", marginBottom: 2, display: 'flex', justifyContent: 'flex-start' }}>
                        <Tabs value={tabIndex} onChange={handleChange} centered>
                            <Tab label={t("general")} />
                            <Tab label={t('laborTask')} />
                        </Tabs>
                    </Box>
                    <br></br>

                    {tabIndex === 0 && (
                        <Box>
                            {userInfo?.role === UserRole.AltisAdmin ? (
                                <Form.Item
                                    name="companyId"
                                    label={t('Select company')}
                                    rules={[{ required: true, message: t('please_select_a_company') }]}
                                    initialValue={selectedCompany}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t('company_name')}
                                        style={{ marginBottom: '6px' }}
                                        filterOption={filterOption}
                                        onChange={(value) => {
                                            setSelectedCompany(value);
                                            fetchActivity(value);
                                        }}
                                    >
                                        {companyData?.map((company) => (
                                            <Select.Option key={company.companyId} value={company.companyId}>
                                                {company.companyName}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            ) : (
                                <Form.Item
                                    name="companyId"
                                    initialValue={userInfo?.companyId}
                                    hidden
                                >
                                    <Input type="hidden" />
                                </Form.Item>
                            )}

                            {/* <Form.Item
                                name="maintenanceType"
                                label={t('Select maintenance')}
                                rules={[{ required: true, message: t('please_select_maintenance_type') }]}
                            >
                                <Select
                                    placeholder={t('Select maintenance')}
                                    style={{ marginBottom: '6px' }}
                                    onChange={handleMaintenanceTypeChange}
                                >
                                    <Select.Option value={1}>{t('Periodic Maintenance')}</Select.Option>
                                    <Select.Option value={2}>{t('Fault Maintenance')}</Select.Option>
                                </Select>
                            </Form.Item> */}


                            <Form.Item
                                name='activityId'
                                label={
                                    <Tooltip title={t('maintenance_code')}>
                                        {t('maintenance_code')}
                                    </Tooltip>
                                }
                                rules={[{ required: true, message: t('maintenance_code') }]}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Select
                                        placeholder={t('maintenance_code')}
                                        style={{ flex: 1 }}
                                        dropdownStyle={{ minWidth: 300 }}
                                        filterOption={filterOption}
                                        showSearch
                                        value={selectedActivity}
                                        onChange={(value) => {
                                            setSelectedActivity(value);
                                            form.setFieldsValue({ activityId: value });
                                        }}
                                    >
                                        {activityData?.map(row => (
                                            <Select.Option key={row.activityId} value={row.activityId}>
                                                {row.activityName}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={showModalCare}
                                    />
                                </div>
                            </Form.Item>

                            <Modal
                                visible={isModalVisibleCare}
                                footer={null}
                                onCancel={handleCancelCare}
                                width={790}
                                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
                            >
                                <div style={{ flex: 1 }}>
                                    <AddActivityName
                                        cancelModal={handleCancelCare}
                                        savedObj={savedNewCare}
                                        companyId={selectedCompany}
                                        activityName={careData?.activityName}
                                        onSetPage={props.onSetPage}
                                        getPageData={props.getPageData}
                                        maintenanceType={1}
                                    />
                                </div>
                            </Modal>

                            <>
                                <Form.Item
                                    label={
                                        <div style={{ display: 'flex', alignItems: 'center', minHeight: '24px' }}>
                                            <Tooltip title={t('start_date_info')} placement="right">
                                                <InfoCircleOutlined style={{
                                                    color: '#1890ff',
                                                    cursor: 'pointer',
                                                    fontSize: '16px',
                                                    marginRight: '8px',
                                                    width: '16px'
                                                }} />
                                            </Tooltip>
                                            {t('activity_start_date')}
                                        </div>
                                    }
                                    name="maintenanceStartDate"
                                    rules={[{ required: true, message: t('select_date_time') }]}
                                >
                                    <DatePicker
                                        showTime
                                        format="DD-MM-YYYY HH:mm"
                                        placeholder={t('select_date_time')}
                                        style={{ borderRadius: '5px', width: '100%' }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label={
                                        <div style={{ display: 'flex', alignItems: 'center', minHeight: '24px' }}>
                                            <Tooltip title={t('finish_date_info')} placement="right">
                                                <InfoCircleOutlined style={{
                                                    color: '#1890ff',
                                                    cursor: 'pointer',
                                                    fontSize: '16px',
                                                    marginRight: '8px',
                                                    marginLeft: '9px',
                                                    width: '16px'
                                                }} />
                                            </Tooltip>
                                            {t('maintenanceFinishDate')}
                                        </div>
                                    }
                                    name="maintenanceFinishDate"
                                >
                                    <DatePicker
                                        showTime
                                        format="DD-MM-YYYY HH:mm"
                                        placeholder={t('select_date_time')}
                                        style={{ borderRadius: '5px', width: '100%' }}
                                    />
                                </Form.Item>
                            </>

                            <Form.Item
                                name="Priority"
                                label={t('Priority')}
                                rules={[{ required: true, message: t('Priority') }]}
                            >
                                <Select
                                    placeholder={t('Priority')}
                                    style={{ marginBottom: '6px' }}
                                >
                                    <Select.Option value={0}>{t('Low')}</Select.Option>
                                    <Select.Option value={1}>{t('Medium')}</Select.Option>
                                    <Select.Option value={2}>{t('High')}</Select.Option>
                                    <Select.Option value={3}>{t('Highest')}</Select.Option>
                                </Select>
                            </Form.Item>

                            <Form.Item
                                label={t('maintenanceResponsible')}
                                name="maintenanceExternalResponsibleName"
                                rules={[{ required: true, message: t('maintenanceResponsible') }]}
                            >
                                <Dropdown
                                    placeholder={t('maintenanceResponsible')}
                                    dataSource={userData}
                                    allowCustomValue={true}
                                    valueKey="userId"
                                    style={{ width: '100%' }}
                                    includeEmptyOption={false}
                                    labelKey="displayName"
                                    onChange={(value) => {
                                        const selectedUser = userData?.find(u => u.displayName === value || u.userId === value);
                                        form.setFieldsValue({
                                            maintenanceExternalResponsibleName: selectedUser ? selectedUser.displayName : value,
                                            maintenanceResponsibleUserId: selectedUser ? selectedUser.userId : null,
                                            maintenanceExternalResponsibleMail: selectedUser?.userEmail || undefined
                                        });
                                    }}
                                />
                            </Form.Item>

                            <Form.Item name="maintenanceResponsibleUserId" hidden>
                                <Input type="hidden" />
                            </Form.Item>

                            <Form.Item
                                label={t('email')}
                                name="maintenanceExternalResponsibleMail"
                                rules={[{ required: true }]}
                            >
                                <Dropdown
                                    placeholder={t('email')}
                                    dataSource={userData}
                                    valueKey="userEmail"
                                    labelKey="userEmail"
                                    style={{ width: '100%' }}
                                    includeEmptyOption={false}
                                    allowCustomValue={true}
                                />
                            </Form.Item>

                            <Form.Item
                                label={t('description_activity')}
                                name="description"
                                rules={[{ required: true, message: t('enter_description') }]}
                            >
                                <Input placeholder={t('enter_description')} style={{ borderRadius: '5px' }} />
                            </Form.Item>

                            <>
                                <Form.Item
                                    name='repeatActivity'
                                    label={t('repeat_activity')}
                                    rules={[{ required: true, message: t('repeat_activity') }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t('repeat_activity')}
                                        onChange={(value) => {
                                            setSelectedActivityType(value);
                                            setShowCustomFrequency(value === 'Custom');
                                            setShowRepeatCount(value !== 0);
                                            setRepeatBase(value);
                                            // Hesaplanan tarihleri sıfırla
                                            setCalculatedDates([]);
                                            setRepeatMaintenanceDetail([]);
                                            // Form değerlerini sıfırla
                                            form.setFieldsValue({
                                                repeatCount: undefined,
                                                customRepeatCount: undefined,
                                                frequency: undefined
                                            });
                                        }}
                                    >
                                        <Select.Option value={0}>{t('onetime')}</Select.Option>
                                        <Select.Option value={1}>{t('daily')}</Select.Option>
                                        <Select.Option value={7}>{t('weekly')}</Select.Option>
                                        <Select.Option value={30}>{t('monthly')}</Select.Option>
                                        <Select.Option value={365}>{t('yearly')}</Select.Option>
                                        <Select.Option value="Custom">{t('custom')}</Select.Option>
                                    </Select>
                                </Form.Item>

                                {showRepeatCount && !showCustomFrequency && (
                                    <>
                                        <Form.Item
                                            name="repeatCount"
                                            label={t('repeat_count')}
                                            rules={[
                                                { required: true, message: t('please_enter_repeat_count') },
                                                { pattern: /^[0-9]*$/, message: t('please_enter_valid_number') }
                                            ]}
                                        >
                                            <Input
                                                placeholder={t('enter_repeat_count')}
                                                style={{ borderRadius: '5px' }}
                                                type="number"
                                                min={1}
                                                onChange={handleRepeatCountChange}
                                            />
                                        </Form.Item>

                                        {calculatedDates.length > 0 && (
                                            <div style={calculatedDatesStyles.container}>
                                                <div style={calculatedDatesStyles.header}>
                                                    {t('calculated_dates')}:
                                                </div>
                                                {calculatedDates.map((date, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            ...calculatedDatesStyles.dateRow,
                                                            backgroundColor: index % 2 === 0 ? '#fff' : '#f5f5f5'
                                                        }}
                                                    >
                                                        {index + 1}. {date}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}

                                {showCustomFrequency && (
                                    <>
                                        <Form.Item
                                            name="customRepeatCount"
                                            label={t('repeat_count')}
                                            rules={[
                                                { required: true, message: t('please_enter_repeat_count') },
                                                { pattern: /^[0-9]*$/, message: t('please_enter_valid_number') }
                                            ]}
                                        >
                                            <Input
                                                placeholder={t('enter_repeat_count')}
                                                style={{ borderRadius: '5px' }}
                                                type="number"
                                                min={1}
                                                onChange={(e) => {
                                                    const frequency = form.getFieldValue('frequency');
                                                    const count = Number(e.target.value);
                                                    const startDate = form.getFieldValue('maintenanceStartDate');

                                                    if (startDate && frequency && count) {
                                                        const dates = calculateDates(startDate, frequency, count);
                                                        setCalculatedDates(dates);
                                                    }
                                                }}
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            name="frequency"
                                            label={t('frequency_days')}
                                            rules={[
                                                { required: true, message: t('days') },
                                                { pattern: /^[0-9]*$/, message: t('please_enter_valid_number') }
                                            ]}
                                        >
                                            <Input
                                                placeholder={t('days')}
                                                style={{ borderRadius: '5px' }}
                                                type="number"
                                                min={1}
                                                onChange={(e) => {
                                                    const count = form.getFieldValue('customRepeatCount');
                                                    const frequency = Number(e.target.value);
                                                    const startDate = form.getFieldValue('maintenanceStartDate');

                                                    if (startDate && frequency && count) {
                                                        const dates = calculateDates(startDate, frequency, count);
                                                        setCalculatedDates(dates);
                                                    }
                                                }}
                                            />
                                        </Form.Item>

                                        {calculatedDates.length > 0 && (
                                            <div style={calculatedDatesStyles.container}>
                                                <div style={calculatedDatesStyles.header}>
                                                    {t('calculated_dates')}:
                                                </div>
                                                {calculatedDates.map((date, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            ...calculatedDatesStyles.dateRow,
                                                            backgroundColor: index % 2 === 0 ? '#fff' : '#f5f5f5'
                                                        }}
                                                    >
                                                        {index + 1}. {date}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </>

                            <Button
                                onClick={showModal}
                                type="primary"
                                style={{ marginTop: 10, marginRight: 10, borderRadius: '5px' }}
                                icon={<UnorderedListOutlined />}
                            >
                                {t('first_datagrid')}
                            </Button>

                            <Modal
                                title={t('first_datagrid')}
                                visible={isModalVisible}
                                onCancel={handleModalCancel}
                                width={1200}
                                footer={[
                                    <Button
                                        key="add"
                                        type="primary"
                                        onClick={() => {
                                            handleAddSelectedItems();
                                            handleModalCancel();
                                        }}
                                    >
                                        {t('add_selected_items')}
                                    </Button>
                                ]}
                            >
                                <MUIDatagrid
                                    data={inventoryData?.data}
                                    columns={columns}
                                    enableSelection={true}
                                    onSelectionChange={handleRowSelection}
                                    onChange={InventoryFilter}
                                    filterMode='server'
                                    total={inventoryData?.count}
                                    defaultPageSize={10}
                                />
                            </Modal>

                            <MUIDatagrid
                                data={careData?.repeatMaintenanceTBL}
                                columns={columns1}
                                onChange={InventoryFilter}
                                total={careData?.count}
                            />

                            <Form.Item>
                                <Row gutter={[4, 4]} justify="end" align="middle">
                                    <Col xs={12} sm={4}>
                                        <Button
                                            block
                                            onClick={handleCancel}
                                            type="primary"
                                            style={{
                                                height: 64,
                                                backgroundColor: 'transparent',
                                                color: '#1890ff',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 10px',
                                                border: 'none',
                                                transition: 'all 0.3s ease',
                                                cursor: 'pointer'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                                e.currentTarget.style.color = '#40a9ff';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.boxShadow = 'none';
                                                e.currentTarget.style.color = '#1890ff';
                                            }}
                                        >
                                            <CloseOutlined style={{ fontSize: 20 }} />
                                            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                                {t('cancel')}
                                            </span>
                                        </Button>
                                    </Col>
                                    <Col xs={12} sm={4}>
                                        <Button
                                            block
                                            htmlType="submit"
                                            type="primary"
                                            style={{
                                                height: 64,
                                                backgroundColor: 'transparent',
                                                color: '#1890ff',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 10px',
                                                border: 'none',
                                                transition: 'all 0.3s ease',
                                                cursor: 'pointer'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                                e.currentTarget.style.color = '#40a9ff';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.boxShadow = 'none';
                                                e.currentTarget.style.color = '#1890ff';
                                            }}
                                        >
                                            <SaveOutlined style={{ fontSize: 20 }} />
                                            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                                {t('save')}
                                            </span>
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </Box>
                    )}

                    {tabIndex === 1 && (
                        <Box>
                            <LaborTask
                                selectedActivityId={form.getFieldValue('activityId')}
                                formItemStyle={{ marginBottom: '16px' }}
                            />
                        </Box>
                    )}
                </Card>
            </Form>
        </>
    );
};

export default AddCare;
